<template>
  <div class="animationBees">
    <div v-bind:class="{ 'container-animation': animationStart }">
      <!-- The box -->
      <!-- <span class="box-container animated infinite bounce"> </span> -->
      <!-- Bees swarm  1 -->
      <div class="swarm1">
        <span class="bees-container first">
          <span class="bees"
            ><img
              class="abee abee--1"
              src="../assets/images/bees/bee__1.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container second">
          <span class="bees"
            ><img
              class="abee abee--2"
              src="../assets/images/bees/bee__2.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container third">
          <span class="bees"
            ><img
              class="abee abee--3"
              src="../assets/images/bees/bee__3.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container fourth">
          <span class="bees"
            ><img
              class="abee abee--4"
              src="../assets/images/bees/bee__4.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container fifth">
          <span class="bees"
            ><img
              class="abee abee--5"
              src="../assets/images/bees/bee__5.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container sixth">
          <span class="bees"
            ><img
              class="abee abee--6"
              src="../assets/images/bees/bee__6.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container seventh">
          <span class="bees"
            ><img
              class="abee abee--7"
              src="../assets/images/bees/bee__7.svg"
              alt="Pszczółka"
          /></span>
        </span>
      </div>
      <!-- Bees swarm  2 -->
      <div class="swarm2">
        <span class="bees-container first">
          <span class="bees"
            ><img
              class="abee abee--1"
              src="../assets/images/bees/bee__7.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container second">
          <span class="bees"
            ><img
              class="abee abee--2"
              src="../assets/images/bees/bee__6.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container third">
          <span class="bees"
            ><img
              class="abee abee--3"
              src="../assets/images/bees/bee__5.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container fourth">
          <span class="bees"
            ><img
              class="abee abee--4"
              src="../assets/images/bees/bee__4.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container fifth">
          <span class="bees"
            ><img
              class="abee abee--5"
              src="../assets/images/bees/bee__3.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container sixth">
          <span class="bees"
            ><img
              class="abee abee--6"
              src="../assets/images/bees/bee__2.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container seventh">
          <span class="bees"
            ><img
              class="abee abee--7"
              src="../assets/images/bees/bee__1.svg"
              alt="Pszczółka"
          /></span>
        </span>
      </div>
      <!-- Bees swarm  3 -->
      <div class="swarm3">
        <span class="bees-container first">
          <span class="bees"
            ><img
              class="abee abee--1"
              src="../assets/images/bees/bee__1.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container second">
          <span class="bees"
            ><img
              class="abee abee--2"
              src="../assets/images/bees/bee__2.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container third">
          <span class="bees"
            ><img
              class="abee abee--3"
              src="../assets/images/bees/bee__3.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container fourth">
          <span class="bees"
            ><img
              class="abee abee--4"
              src="../assets/images/bees/bee__4.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container fifth">
          <span class="bees"
            ><img
              class="abee abee--5"
              src="../assets/images/bees/bee__5.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container sixth">
          <span class="bees"
            ><img
              class="abee abee--6"
              src="../assets/images/bees/bee__6.svg"
              alt="Pszczółka"
          /></span>
        </span>
        <span class="bees-container seventh">
          <span class="bees"
            ><img
              class="abee abee--7"
              src="../assets/images/bees/bee__7.svg"
              alt="Pszczółka"
          /></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Animation",
  data() {
    return {
      animationStart: true,
    };
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {},
  },

  components: {},
  props: {
    showAnomation: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
// For constructing animation for curve line
@mixin curve-line-animation(
  $xDisplacement,
  $yDisplacement,
  $uniqueIdentifier,
  $disappearAt: 85%,
  $initialSize: 48,
  $endSize: 24
) {
  @keyframes curve-x-axis-#{$uniqueIdentifier} {
    0% {
      opacity: 1;
      font-size: $initialSize + px;
      animation-timing-function: ease-in;
    }
    50% {
      transform: translateX($xDisplacement + px);
      animation-timing-function: ease-out;
    }
    #{$disappearAt} {
      font-size: $endSize + px;
      opacity: 0;
    }
    100% {
      transform: translateX($xDisplacement * 2 + px);
      opacity: 0;
    }
  }

  @keyframes curve-y-axis-#{$uniqueIdentifier} {
    0% {
      animation-timing-function: ease-out;
    }
    50% {
      transform: translateY($yDisplacement + px);
      animation-timing-function: ease-in;
    }
    100% {
      transform: translateX(0px);
    }
  }
}

// Helper for adding animation in different bees
@mixin beesStyleHelper(
  $identifier,
  $xDisplacement,
  $yDisplacement,
  $animationSpeed,
  $animationDelay,
  $disappearAt: 85%,
  $initialSize: 48,
  $endSize: 24
) {
  @include curve-line-animation(
    $xDisplacement,
    $yDisplacement,
    $identifier,
    $disappearAt,
    $initialSize,
    $endSize
  );
  animation: curve-x-axis-#{$identifier} $animationSpeed $animationDelay infinite;
  //animation: curve-x-axis-#{$identifier} $animationSpeed $animationDelay 2;
  .bees {
    animation: curve-y-axis-#{$identifier} $animationSpeed $animationDelay infinite;
  }
}

// Helper for random number gen
@function r($min, $max) {
  $rand: random();
  $randomNum: $min + ($rand * (($max - $min)));
  @return $randomNum;
}

.abee {
  transform: rotate(-90deg);
  &--1 {
    height: 1.15rem;
    transform: rotate(-100deg);
  }
  &--2 {
    height: 1.05rem;
  }
  &--3 {
    height: 1rem;
    transform: rotate(-120deg);
  }
  &--3 {
    height: 1.4rem;
    transform: rotate(-60deg);
  }
}

.container-animation {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 0;
  font-size: 48px;
  position: relative;
  z-index: 999;
  transform: rotate(90deg) translate(-2rem, -1.5rem);

  .box-container {
    position: absolute;
    font-size: 120px;
    z-index: 100;
    .box {
      display: flex;
      align-items: center;
      justify-content: center;
      &:after {
        content: "";
        position: absolute;
        width: 80%;
        height: 50%;
        z-index: -1;
      }
    }
  }

  .bees-container {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    .bees {
      position: absolute;
      z-index: 8888888;
    }
  }

  .swarm1 {
    $x-min: -100;
    $x-max: 100;
    $y-min: -50;
    $y-max: -200;
    $a-spd-min: 2;
    $a-spd-max: 5;
    $a-delay-min: 0;
    $a-delay-max: 2;
    $dis-pt-min: 70;
    $dis-pt-max: 85;
    $font-min: 12;
    $font-max: 84;

    .bees-container {
      &.bee {
        @include beesStyleHelper(
          11,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.bee2 {
        @include beesStyleHelper(
          11,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.second {
        @include beesStyleHelper(
          12,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.third {
        @include beesStyleHelper(
          13,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.fourth {
        @include beesStyleHelper(
          14,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.fifth {
        @include beesStyleHelper(
          15,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.sixth {
        @include beesStyleHelper(
          16,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.seventh {
        @include beesStyleHelper(
          17,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
    }
  }

  .swarm2 {
    $x-min: 100;
    $x-max: 200;
    $y-min: -100;
    $y-max: -200;
    $a-spd-min: 1;
    $a-spd-max: 3;
    $a-delay-min: 0;
    $a-delay-max: 1;
    $dis-pt-min: 85;
    $dis-pt-max: 95;
    $font-min: 12;
    $font-max: 84;

    .bees-container {
      &.bee {
        @include beesStyleHelper(
          21,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.first {
        @include beesStyleHelper(
          21,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.second {
        @include beesStyleHelper(
          22,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.third {
        @include beesStyleHelper(
          23,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.fourth {
        @include beesStyleHelper(
          24,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.fifth {
        @include beesStyleHelper(
          25,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.sixth {
        @include beesStyleHelper(
          26,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.seventh {
        @include beesStyleHelper(
          27,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
    }
  }

  .swarm3 {
    $x-min: -200;
    $x-max: -200;
    $y-min: -300;
    $y-max: -200;
    $a-spd-min: 2;
    $a-spd-max: 5;
    $a-delay-min: 0.5;
    $a-delay-max: 1;
    $dis-pt-min: 85;
    $dis-pt-max: 95;
    $font-min: 12;
    $font-max: 84;

    .bees-container {
      &.first {
        @include beesStyleHelper(
          31,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.second {
        @include beesStyleHelper(
          32,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.third {
        @include beesStyleHelper(
          33,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.fourth {
        @include beesStyleHelper(
          34,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.fifth {
        @include beesStyleHelper(
          35,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.sixth {
        @include beesStyleHelper(
          36,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
      &.seventh {
        @include beesStyleHelper(
          37,
          r($x-min, $x-max),
          r($y-min, $y-max),
          r($a-spd-min, $a-spd-max) + s,
          r($a-delay-min, $a-delay-max) + s,
          percentage(r($dis-pt-min, $dis-pt-max)),
          r($font-min, $font-max),
          r($font-min, $font-max)
        );
      }
    }
  }
}
</style>
